export default "__VITE_ASSET__DNPxrFJP__"